var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.122,9.88 c1.171,1.171,1.171,3.072,0,4.245c-1.171,1.171-3.072,1.171-4.245,0c-1.171-1.171-1.171-3.072,0-4.245 C11.05,8.707,12.95,8.707,14.122,9.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3,12 c0-0.659,0.152-1.311,0.446-1.912l0,0C4.961,6.991,8.309,5,12,5c3.691,0,7.039,1.991,8.554,5.088l0,0 C20.848,10.689,21,11.341,21,12c0,0.659-0.152,1.311-0.446,1.912l0,0C19.039,17.009,15.691,19,12,19 c-3.691,0-7.039-1.991-8.554-5.088l0,0C3.152,13.311,3,12.659,3,12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24H0V0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b0eae17db5b802bd7e449e4b3bda6a2e.svg";
export { ForwardRef as ReactComponent };